/*
 * K-Beauty Real Gems — cart drawer (Phase 3).
 * Vanilla AJAX against Shopify's Cart API + Section Rendering API.
 *
 *   Endpoints:
 *     POST /cart/add.js     — add a variant
 *     POST /cart/change.js  — change qty by line key/index (qty: 0 removes)
 *     GET  /cart.js         — read current cart
 *
 *   Section re-render: every mutating call passes `sections: "krg-cart-drawer"`
 *   so Shopify returns fresh HTML for the drawer; we swap the drawer body
 *   in-place and update the bag count from the cart JSON.
 */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '[data-krg-cart-drawer]';
  var DRAWER_SECTION  = 'krg-cart-drawer';
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var drawer = document.querySelector(DRAWER_SELECTOR);
  var scrim  = document.querySelector('[data-krg-cart-scrim]');
  var body   = document.body;

  /* ---------- Open / close ---------- */
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('krg-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('krg-cart-scrim--open');
    body.classList.add('krg-cart-open');
    // Recompute slider nav now that the drawer is visible (dimensions are real).
    initRecNav();
    updateFreeShipBar();
    // Close mobile nav if open
    var mn = document.querySelector('[data-krg-mobile-nav]');
    if (mn && mn.classList.contains('krg-mobile-nav--open')) {
      mn.classList.remove('krg-mobile-nav--open', 'krg-mobile-nav--shop');
      mn.setAttribute('aria-hidden', 'true');
      var t = document.querySelector('.krg-menu-toggle--open');
      if (t) t.classList.remove('krg-menu-toggle--open');
      body.classList.remove('krg-nav-open');
    }
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('krg-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('krg-cart-scrim--open');
    body.classList.remove('krg-cart-open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('krg-cart-drawer--open')) closeCart();
  });
  if (scrim) scrim.addEventListener('click', closeCart);

  // Open triggers: .js-cart-open (Bag link, mobile drawer row) + close button.
  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('.js-cart-open, [data-krg-cart-toggle]');
    if (openEl) {
      e.preventDefault();
      openCart();
      return;
    }
    var closeEl = e.target.closest('[data-krg-cart-close]');
    if (closeEl) {
      e.preventDefault();
      closeCart();
      return;
    }
  });

  /* ---------- Section re-render helpers ---------- */
  function swapDrawerBody(html) {
    if (!drawer || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    // The response wraps our section in <div id="shopify-section-krg-cart-drawer">.
    var fresh = tmp.querySelector('#shopify-section-' + DRAWER_SECTION + ' ' + DRAWER_SELECTOR)
             || tmp.querySelector(DRAWER_SELECTOR);
    if (!fresh) return;
    // Preserve open state across swap.
    var wasOpen = drawer.classList.contains('krg-cart-drawer--open');
    drawer.innerHTML = fresh.innerHTML;
    if (wasOpen) drawer.classList.add('krg-cart-drawer--open');
    // The re-rendered drawer already carries the up-to-date count in its title,
    // so sync the header bag count from it — no extra /cart.js round-trip needed.
    var paren = drawer.querySelector('[data-krg-cart-count-paren]');
    if (paren) {
      var m = paren.textContent.match(/\d+/);
      if (m) updateBagCount(m[0]);
    }
    initRecNav();
    updateFreeShipBar();
  }

  /* ---------- Free-shipping bar (multi-currency) ----------
   * The threshold is stored in the shop's BASE currency, but `cart.total_price`
   * (and the data-cart-total we render from it) is in the buyer's PRESENTMENT
   * currency — so a fixed number can't be compared across markets. Convert the
   * threshold with the active market rate (Shopify.currency.rate) and compare in
   * presentment subunits. Intl gives the correct decimal count per currency, so
   * zero-decimal currencies (JPY, VND) work too. The Liquid render is a
   * base-currency-correct fallback; this refines it for every currency.
   */
  function moneyDecimals(iso) {
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: iso }).resolvedOptions().maximumFractionDigits;
    } catch (e) {
      return 2;
    }
  }
  function updateFreeShipBar() {
    if (!drawer) return;
    var el = drawer.querySelector('[data-krg-fs]');
    if (!el) return;

    var thresholdBaseSub = parseInt(el.getAttribute('data-fs-threshold'), 10) || 0;
    if (thresholdBaseSub <= 0) { el.hidden = true; return; }
    var baseCur = el.getAttribute('data-fs-base-currency') || 'USD';
    var iso = el.getAttribute('data-cart-currency') || baseCur;
    var cartSub = parseInt(el.getAttribute('data-cart-total'), 10) || 0;

    // Shopify.currency.rate = presentment units per 1 base unit (1.0 in the base market).
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!rate || rate <= 0) rate = 1;

    var thresholdMajor = thresholdBaseSub / Math.pow(10, moneyDecimals(baseCur));
    var presDecimals = moneyDecimals(iso);
    var thresholdSub = Math.round(thresholdMajor * rate * Math.pow(10, presDecimals));

    var pct = thresholdSub > 0 ? Math.min(100, (cartSub / thresholdSub) * 100) : 0;
    var remainingSub = Math.max(0, thresholdSub - cartSub);
    var unlocked = remainingSub <= 0;

    var fill = el.querySelector('[data-krg-fs-fill]');
    if (fill) fill.style.width = pct + '%';
    el.classList.toggle('is-unlocked', unlocked);

    var msg = el.querySelector('[data-krg-fs-msg]');
    if (msg) {
      if (unlocked) {
        msg.innerHTML = "You've unlocked <strong>complimentary shipping</strong>.";
      } else {
        var remainingMajor = remainingSub / Math.pow(10, presDecimals);
        var formatted;
        try {
          formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: iso }).format(remainingMajor);
        } catch (e) {
          formatted = remainingMajor.toFixed(presDecimals);
        }
        msg.innerHTML = "You're <strong class=\"ship-amt\">" + formatted + "</strong> away from complimentary shipping.";
      }
    }
    el.hidden = false;
  }

  function updateBagCount(count) {
    document.querySelectorAll('[data-krg-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-krg-cart-count-paren]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  /* ---------- AJAX wrappers ---------- */
  function cartAdd(variantId, quantity) {
    var qty = parseInt(quantity, 10) || 1;
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: qty }],
        sections: DRAWER_SECTION
      })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[DRAWER_SECTION]) {
          swapDrawerBody(data.sections[DRAWER_SECTION]); // also syncs bag count
        } else {
          return fetchCartAndSync(); // fallback only if the section render is missing
        }
        return data;
      });
  }

  function cartChange(line, quantity) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: parseInt(quantity, 10),
        sections: DRAWER_SECTION
      })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[DRAWER_SECTION]) swapDrawerBody(data.sections[DRAWER_SECTION]);
        if (typeof data.item_count === 'number') updateBagCount(data.item_count);
        return data;
      });
  }

  function fetchCartAndSync() {
    return fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBagCount(cart.item_count);
        return cart;
      });
  }

  /* ---------- Delegated handlers (survive section swaps) ---------- */
  document.addEventListener('click', function (e) {
    var incr = e.target.closest('[data-krg-qty-incr]');
    var decr = e.target.closest('[data-krg-qty-decr]');
    var rm   = e.target.closest('[data-krg-qty-remove]');
    // [data-krg-rec-add] = cart-drawer recs; [data-krg-card-add] = collection
    // cards + PDP "Complete the Routine". Both add a variant and open the drawer.
    var add  = e.target.closest('[data-krg-rec-add], [data-krg-card-add]');

    if (incr || decr || rm) {
      e.preventDefault();
      var line = (incr || decr || rm).closest('[data-krg-line-index]');
      if (!line) return;
      var index = parseInt(line.getAttribute('data-krg-line-index'), 10);
      var nEl = line.querySelector('[data-krg-qty-n]');
      var current = parseInt((nEl && nEl.textContent) || '1', 10);
      var nextQty;
      if (rm) nextQty = 0;
      else if (incr) nextQty = current + 1;
      else nextQty = Math.max(0, current - 1);
      cartChange(index, nextQty);
      return;
    }

    if (add) {
      e.preventDefault();
      var variantId = add.getAttribute('data-variant-id');
      if (!variantId) return;
      add.setAttribute('disabled', 'true');
      cartAdd(variantId, 1).finally(function () { add.removeAttribute('disabled'); });
      // After adding, ensure drawer is open.
      openCart();
      return;
    }
  });

  /* ---------- Add-to-cart forms anywhere on the page ----------
   * Hook any <form action="/cart/add">: intercept submit, POST via AJAX,
   * swap drawer, open. Pickup will apply to the future PDP/quick-add too.
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/i.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', DRAWER_SECTION);
    openCart(); // open immediately (optimistic) so it feels instant
    fetch(routes + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[DRAWER_SECTION]) {
          swapDrawerBody(data.sections[DRAWER_SECTION]); // also syncs bag count
        } else {
          return fetchCartAndSync();
        }
      });
  });

  /* ---------- "Complete the Routine" slider nav ----------
   * The rec track is a hidden-scrollbar scroll-snap row. Show prev/next arrows
   * only when it overflows, and disable them at the start/end. Re-run after each
   * drawer re-render (swapDrawerBody) and on open, since dimensions change.
   */
  function initRecNav() {
    if (!drawer) return;
    var track = drawer.querySelector('[data-krg-rec-track]');
    var nav   = drawer.querySelector('[data-krg-rec-nav]');
    if (!track || !nav) return;
    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 1;
      nav.hidden = !overflow;
      if (!overflow) return;
      var prev = nav.querySelector('[data-krg-rec-prev]');
      var next = nav.querySelector('[data-krg-rec-next]');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }
    if (!track._krgRecBound) {
      track._krgRecBound = true;
      track.addEventListener('scroll', update, { passive: true });
    }
    update();
  }

  // Delegated so it survives drawer section swaps.
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-krg-rec-prev], [data-krg-rec-next]');
    if (!arrow) return;
    e.preventDefault();
    var rec = arrow.closest('[data-krg-cart-rec]');
    var track = rec && rec.querySelector('[data-krg-rec-track]');
    if (!track) return;
    var card = track.querySelector('.krg-rec-card');
    var gap = 13; // matches .krg-cart-rec-track gap
    var step = card ? (card.offsetWidth + gap) * 2 : Math.round(track.clientWidth * 0.85);
    var dir = arrow.hasAttribute('data-krg-rec-next') ? 1 : -1;
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  });

  // Keep arrow visibility/edge state correct when the viewport (and thus the
  // drawer width) changes while the drawer is open.
  var recResizeT;
  window.addEventListener('resize', function () {
    clearTimeout(recResizeT);
    recResizeT = setTimeout(initRecNav, 150);
  });

  // Initial state (drawer is server-rendered in the DOM at load).
  initRecNav();
  updateFreeShipBar();

  // Expose for other scripts / debug.
  window.KRGCart = { open: openCart, close: closeCart, add: cartAdd, change: cartChange, refresh: fetchCartAndSync };
})();
